<nav class="layout-breadcrumb hidden">
    <ol>
        <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
            <li>{{ item.label }}</li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> /</li>
        </ng-template>
    </ol>
    <div *ngIf="additionalTitle" class="subtitle">
        <i class="pi pi-angle-right"></i>&nbsp; {{additionalTitle}}
    </div>
</nav>
